import React, { Component } from 'react';
import './footer.css';

class Footer extends Component {
    render() {
      return (
        <React-Fragment>
          <footer>
              Copyright © 2015-2019 alsoug.com
          </footer>
        </React-Fragment>
      );
    }
  }
  
  export default Footer;